"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function Left(props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("polygon", { fill: "currentColor", points: "5.655 3.471 5.655 10.47 12.655 10.471 12.655 12.471 3.655 12.471 3.655 3.471", transform: "scale(1 -1) rotate(45 27.398 0)" })));
}
exports.default = Left;
//# sourceMappingURL=Left.js.map